import React from 'react';
import styled from 'styled-components';
import { RoundButtons } from './button';

const Container = styled.div`
  position: relative;
  min-height: 250px;
  cursor: pointer;
`;
const InputContainer = styled.input`
  height: 100%;
  width: 100%;
  min-height: 250px;
  position: absolute;
  z-index: 2;
  opacity: 0;
`;

export function RoundInput(props) {
  return (
    <Container>
      <InputContainer {...props} />
      <RoundButtons type="button" title={'Click to open camera'} />
    </Container>
  );
}
